/* 🤖 this file was generated by svg-to-ts*/
export const iconSpecificGravity: {
  name: 'specific_gravity';
  data: string;
} = {
  name: 'specific_gravity',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M22 0H2a1 1 0 00-.92.6 1 1 0 00.19 1.08L5 5.71V23a1 1 0 001 1h16a1 1 0 001-1V1a1 1 0 00-1-1zm-1 22H7v-3h2a1 1 0 000-2H7v-1h2a1 1 0 000-2H7v-1h2a1 1 0 000-2H7V5.32a1 1 0 00-.27-.68L4.29 2H21z"/><circle cx="14.5" cy="17.5" r="1.5"/><circle cx="14" cy="13" r="1"/><circle cx="18" cy="14" r="1"/><circle cx="16.5" cy="9.5" r=".5"/></svg>`,
};
